'use client'
import { useTranslations } from 'next-intl'
import { PageHero } from '@/components/page-hero'
import { RestaurantCityBrandsLink } from '@/features/restaurants/restaurants-city-search/restaurant-city-brands-link'
import { RestaurantCitySeoDescription } from '@/features/restaurants/restaurants-city-search/restaurant-city-seo-description'
import { useRestaurantCitySearchContext } from '@/features/restaurants/restaurants-city-search/utils/restaurant-city-search-context'

interface IRestaurantsCityHeaderProps {
    citySlug: string
}

export const RestaurantsCityHeader = ({ citySlug }: IRestaurantsCityHeaderProps) => {
    const { city } = useRestaurantCitySearchContext()
    const t = useTranslations()

    return (
        <PageHero
            title={t('restaurants.city.restaurantsIn', { cityName: city?.name ?? '' })}
            description={
                <>
                    {/* Clamped on mobile rather than hidden: Google indexes mobile-first,
                        so the h1 and this copy must stay visible in the DOM. */}
                    <RestaurantCitySeoDescription
                        citySlug={citySlug}
                        className="line-clamp-3 md:line-clamp-none"
                    />

                    <RestaurantCityBrandsLink citySlug={citySlug} />
                </>
            }
        />
    )
}
